define('app/sds/attribute/list/sds-attribute-list',["$q"], function ($q) {
	function safeFunction(fn, ifNot) {
		return angular.isFunction(fn) ? fn : (arguments.length > 1 ? ifNot : angular.noop);
	}
	return {
		controller: {
			bind: {
				"_source": "=?source",
				"attrFlex": "@?"
			},
			properties: {
				source: function () { return this._source || {}; },

				//add: function () { return this.source.add; },
				//update: function () { return this.source.update; },
				//delete: function () { return this.source.delete; },

				_canAdd: function _canAdd_get() { return safeFunction(this.source.canAdd); },
				_canUpdate: function _canUpdate_get() { return safeFunction(this.source.canUpdate); },
				_canDelete: function _canDelete_get() { return safeFunction(this.source.canDelete); },

				attributes: function attributes_get() { return this.source.attributes || this.source.items || this.source; },

				addableAttributes: function () { }
			},
			prototype: {
				add: function add() {
					return safeFunction(this.source.add).apply(this.source, arguments)
				},
				update: function update() {
					return safeFunction(this.source.update).apply(this.source, arguments)
				},
				delete: function _delete() {
					var result = safeFunction(this.source.delete).apply(this.source, arguments);
				},
				canAdd: function canAdd(adding) {
					return this.add || this.source.canAdd(adding);
				},
				canUpdate: function canUpdate(updating) {
					return this.update || this.source.canUpdate(updating);
				},
				canDelete: function canDelete(deleting) {
					return this.deleting || this.source.canDelete(deleting);
				}
			},
			constructor: ["$self", "$attrs", function (vm, $attrs) {
				var isDefined = {
					add: "add" in $attrs,
					delete: "delete" in $attrs,
					update: "update" in $attrs
				};
				if (!("attrFlex" in $attrs)) {
					vm.attrFlex = angular.toJson({
						"gt-md": 50,
						default: 100
					});
				}
				angular.extend(vm, {
					canAdd: function canAdd(locals) {
						return isDefined.add && this._canAdd(locals);
					},
					canUpdate: function canUpdate(locals) {
						return isDefined.update && this._canUpdate(locals);
					},
					canDelete: function canDelete(locals) {
						return isDefined.canDelete && this._canDelete(locals);
					}
				});
			}]
		}
	};
});
